module.exports = __webpack_public_path__ + "static/media/Joji - ATTENTION A COLORS SHOW.e9b4a834.mp3";